import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Container from "pages/_components/Container";
import { connect } from "react-redux";
import { compose } from "redux";
import { Form, withFormik, Field } from "formik";
import { func, shape, bool, string } from "prop-types";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import * as schedulerUtils from "util/scheduler";
import * as dateUtils from "util/date";
import Select from "pages/forms/_components/_fields/Select";
import CommonFrequencySubOption from "pages/forms/_components/_scheduler/CommonFrequencySubOption";
import CustomFrequencySubOption from "pages/forms/_components/_scheduler/CustomFrequencySubOption";
import moment from "moment";
import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
import ModalNotification from "pages/forms/_components/ModalNotification";

const STARTS_ON_DATE = moment(new Date()).add(1, "days");

class SchedulerSidebar extends Component {
    static propTypes = {
        goBack: func,
        onScheduleClick: func,
        setTouched: func,
        setErrors: func,
        setIsDisplayed: func,
        touched: shape({}),
        errors: shape({}),
        values: shape({}),
        isDisplayed: bool,
        idForm: string.isRequired,
    };

    static defaultProps = {
        goBack: () => {},
        onScheduleClick: () => {},
        setTouched: () => {},
        setErrors: () => {},
        setIsDisplayed: () => {},
        touched: {},
        errors: {},
        values: {},
        isDisplayed: false,
    };

    goBack = () => {
        const { goBack } = this.props;
        goBack();
    };

    validateFields = () => {
        const { setErrors, errors, touched, setTouched, values } = this.props;
        let res = true;
        // clean errors
        setErrors({});

        const moreThan2daysaWeek = dateUtils.moreThan2daysSelected(values.days);

        // validate if it's week and days is just one day and freqValue = 1
        if (values.customFreq === schedulerUtils.WEEK) {
            if (moreThan2daysaWeek && values.customFreqValue !== "1") {
                setTouched({ ...touched, days: true });
                setErrors({
                    ...errors,
                    days: { value: i18nUtils.get(`scheduler.multipleDaysSelectedValidation`) },
                });
                res = false;
            }
        }
        // starts on must be after than today
        const today = dateUtils.setMidnight(new Date());
        if (moment(values.startsOn).isBefore(today)) {
            setTouched({ ...touched, startsOn: true });
            setErrors({
                ...errors,
                startsOn: i18nUtils.get(`scheduler.startsOnBeforeToday`),
            });
            res = false;
        }

        return res;
    };

    onScheduleClick = () => {
        const { onScheduleClick, values } = this.props;

        if (this.validateFields()) {
            onScheduleClick(values);
        }
    };

    render() {
        const {
            isDisplayed,
            setIsDisplayed,
            values: { lapse, frequency, customFreq },
            errors,
            idForm,
        } = this.props;

        return (
            <Drawer openSidebar={isDisplayed} toggleSidebar={setIsDisplayed}>
                <div className="container">
                    <h2 className="title-content text-center">
                        <I18n id="scheduler.title" />
                    </h2>
                    <div className="row">
                        <Form className="above-the-fold">
                            <Container className="container--layout flex-grow">
                                <ModalNotification idForm={idForm} errors={errors} />
                                <Row className="gap-8">
                                    <Col sm={12} md={8} mdOffset={2} className="form-group form-group--select">
                                        <div className="form-text-group">
                                            <label id={`label.${idForm}.frequency`} className="font-weight-600">
                                                <I18n id="scheduler.frequency" />
                                            </label>
                                        </div>
                                        <div className="input-group-standard">
                                            <Field
                                                id={`${idForm}.frequency`}
                                                component={Select}
                                                label={`label.${idForm}.frequency`}
                                                name="frequency"
                                                className="slideFromBottom"
                                                options={schedulerUtils.listRecurrencies()}
                                                clearable={false}
                                                searchable={false}
                                                aria-owns="endRulesFieldsetID"
                                                aria-haspopup
                                                aria-expanded={isDisplayed}
                                            />
                                        </div>
                                    </Col>
                                    {frequency !== schedulerUtils.CUSTOM ? (
                                        <CommonFrequencySubOption
                                            lapse={lapse}
                                            frequency={frequency}
                                            startsOn={STARTS_ON_DATE}
                                        />
                                    ) : (
                                        <CustomFrequencySubOption
                                            lapse={lapse}
                                            frequency={frequency}
                                            startsOn={STARTS_ON_DATE}
                                            customFreq={customFreq}
                                        />
                                    )}
                                    <Col sm={12} md={8} mdOffset={2}>
                                        <Button
                                            type="button"
                                            bsStyle="primary"
                                            label="scheduler.schedule"
                                            onClick={this.onScheduleClick}
                                            disabled={frequency === schedulerUtils.ONCE ? false : !lapse?.lapse}
                                            block
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = () => ({});

export default compose(
    connect(mapStateToProps),
    withFormik({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: (props) => {
            const { value } = props;

            const newProgram = {
                frequency: schedulerUtils.ONCE,
                startsOn:
                    value && value.valueDate && value.selectedOption === schedulerUtils.ONCE
                        ? moment(value.valueDate).toDate()
                        : STARTS_ON_DATE.toDate(),
                lapse: {
                    date: STARTS_ON_DATE.toDate(),
                    lapse: "",
                },
                customFreq: schedulerUtils.DAY,
                customFreqValue: "1",
                days: dateUtils.getDayFromDate(STARTS_ON_DATE.toDate()),
                occurrenceType: "day", // day(every month on x day ) or occurrence(every month on the "tirth" "tuesday")
            };

            if (!value || !value.program) {
                return newProgram;
            }

            const startsOn =
                typeof value.program.startsOn === "string"
                    ? moment(value.program.startsOn).toDate()
                    : value.program.startsOn;
            return {
                ...value.program,
                startsOn,
                frequency: value.program.isCustom ? schedulerUtils.CUSTOM : value.program.frequency,
                lapse: {
                    lapse: value.program.lapse,
                    date: value.program.date,
                    number: value.program.number,
                },
                customFreq: value.program.frequency,
                customFreqValue: value.program.frequencyValue,
                occurrenceType: value.program.occurrence ? "occurrence" : "day",
            };
        },
    }),
)(SchedulerSidebar);
